import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { VisualAppDispatch, VisualAppState } from './reducer';

export const useVisualDispatch: () => VisualAppDispatch = useDispatch;
export const useVisualSelector: TypedUseSelectorHook<VisualAppState> = useSelector;
